import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "", to = "/", onDark = false }) => {
  const content = (
    <img
      src={onDark ? "/assets/logo-white.png" : "/assets/logo-horizontal.png"}
      alt="Archedia Solutions — Perspective Builds Possibilities"
      className={`logo-crisp block h-10 w-auto max-w-[190px] object-contain transition-opacity duration-300 sm:h-11 sm:max-w-[230px] md:h-12 md:max-w-[260px] lg:h-14 lg:max-w-[300px] ${className}`}
      data-testid="archedia-logo"
      data-variant={onDark ? "white" : "green"}
    />
  );
  if (to) return <Link to={to} aria-label="Archedia Solutions — Home" className="inline-flex items-center">{content}</Link>;
  return content;
};

export default Logo;
